export enum RoleType {
  Board = 1,
  Other = 2
}